import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Info from "./Info";
import { Tabs } from "antd";
import {
  setRefetch,
  setRefetchKey,
} from "../../../../features/global/globalSlice";
import BreadCrumb from "../../../../layout/BreadCrumb";
import MemberTable from "./member/MemberTable";
import ProjectTable from "./project/ProjectTable";

function PartnerList() {
  const dispatch = useDispatch();
  const [active, setactive] = useState("1");
  const { activeObjCatPartners, activeObjPartners } = useSelector((state) => ({
    activeObjCatPartners: state.obj.activeObj["partners-category"],
    activeObjPartners: state.obj.activeObj["partners"],
  }));
  async function refetching(activeKey) {
    setactive(activeKey);
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
  }

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Info</span>
        </span>
      ),
      key: "1",
      children: <Info />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Members</span>
        </span>
      ),
      key: "2",
      children: <MemberTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Projects</span>
        </span>
      ),
      key: "3",
      children: <ProjectTable />,
    },
  ];
  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Irrigation Partners", path: "/irrigation-partner-list" },
          { title: "Irrigation View", path: "/irrigation-partner-view" },
          { title: "partner View", path: "/irrigation-partner-view" },
        ]}
      />
      <div className="white_card mt-[2.41rem] flex-1 min-h-[80vh]">
        <div className="scheme-card-title">{activeObjCatPartners?.ipcName}</div>
        <div className="form-add-h mt-[.5rem]">{activeObjPartners?.mipName}</div>
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="activity-tab-wrap partner-tab partner-bar mt-[2rem]"
        />
      </div>
    </div>
  );
}

export default PartnerList;
